import React, { useState } from 'react';
import { Menu, MenuTrigger, MenuPopover, MenuList, MenuItem, Tooltip } from '@fluentui/react-components';
import {
    MODE_OPTIONS,
    getEligiblePredecessorName,
    getModeTooltip,
} from '../../utils/taskSchedulingUtils';
import styles from './css/index.module.css';

const PARENT_MODE_TOOLTIP = 'Mode applies to schedulable leaf tasks.';

const ModePickerMenu = ({
    task,
    allTasks = [],
    scheduleTasks = null,
    customOrder = null,
    onModeSelect,
    readOnly = false,
    readOnlyReason = null,
    children,
}) => {
    const [open, setOpen] = useState(false);
    const currentMode = task?.mode || 'FS';
    const chainTasks = scheduleTasks?.length ? scheduleTasks : allTasks;
    const predecessorName = getEligiblePredecessorName(task, chainTasks, customOrder);
    const tooltip =
        readOnly && readOnlyReason === 'parent'
            ? PARENT_MODE_TOOLTIP
            : getModeTooltip(currentMode, predecessorName, {
                  showNoPredecessorHint: !readOnly && !predecessorName,
              });

    const tooltipContent = <span style={{ whiteSpace: 'pre-line' }}>{tooltip}</span>;

    const handleSelect = mode => {
        if (readOnly || mode === currentMode) {
            setOpen(false);
            return;
        }
        onModeSelect && onModeSelect(task, mode);
        setOpen(false);
    };

    if (readOnly) {
        return (
            <Tooltip content={tooltipContent} relationship="description" withArrow positioning="above">
                <span
                    className={styles.tableRegularText}
                    style={{ color: '#989BAD', cursor: 'default' }}
                    title={tooltip}>
                    —
                </span>
            </Tooltip>
        );
    }

    return (
        <Menu open={open} onOpenChange={(e, data) => setOpen(data.open)}>
            <MenuTrigger disableButtonEnhancement>
                <Tooltip content={tooltipContent} relationship="description" withArrow positioning="above">
                    <span
                        style={{ display: 'inline-flex', width: '100%', justifyContent: 'center' }}
                        title={tooltip}
                        onPointerDown={e => e.stopPropagation()}
                        onMouseDown={e => e.stopPropagation()}>
                        {children}
                    </span>
                </Tooltip>
            </MenuTrigger>
            <MenuPopover style={{ minWidth: 280 }}>
                <MenuList>
                    {MODE_OPTIONS.map(option => (
                        <MenuItem key={option.value} onClick={() => handleSelect(option.value)}>
                            <div>
                                <div style={{ fontWeight: 600 }}>
                                    {option.value} — {option.shortLabel}
                                </div>
                                <div style={{ fontSize: 12, color: '#5A5F7A' }}>{option.description}</div>
                            </div>
                        </MenuItem>
                    ))}
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default ModePickerMenu;
